import React, { useCallback } from "react";
import { UserLoggedInNavigatorNavigationProp } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { graphql, useMutation } from "react-relay";
import { AHInput, Box } from "arkh";

import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";

import { useNavigationHeader } from "../../../common/navigationHeaderOptions";
import { OrgWorkspaceCreateMutation } from "./__generated__/OrgWorkspaceCreateMutation.graphql";
import { TimezoneSelector } from "./TimezoneSelector";

type ParamList = {
  OrgWorkspaceCreateScreen: {
    workspaceId: string;
    timezone: string;
  };
};

const Stack = createNativeStackNavigator<ParamList>();

export const OrgWorkspaceCreate = withWebModal(() => {
  return (
    <Stack.Navigator>
      <Stack.Screen
        name="OrgWorkspaceCreateScreen"
        component={OrgWorkspaceCreateScreen}
        options={({ navigation }) => ({
          headerTitle: "",
          headerLeft: () => null,
          headerRight: () => null,
        })}
      />
    </Stack.Navigator>
  );
});

type OrgWorkspaceCreateScreenProps = {
  route: RouteProp<ParamList, "OrgWorkspaceCreateScreen">;
  navigation: CompositeNavigationProp<
    UserLoggedInNavigatorNavigationProp<"OrgWorkspaceCreate">,
    NativeStackNavigationProp<ParamList, "OrgWorkspaceCreateScreen">
  >;
};

function OrgWorkspaceCreateScreen(props: OrgWorkspaceCreateScreenProps) {
  const [name, setName] = React.useState("");
  const [timezone, setTimezone] = React.useState(props.route.params.timezone);
  const [createWorkspace, creatWorkspaceLoading] =
    useMutation<OrgWorkspaceCreateMutation>(graphql`
      mutation OrgWorkspaceCreateMutation(
        $name: String!
        $workspaceId: ID!
        $timezone: String!
      ) {
        workspace(id: $workspaceId) {
          createSubWorkspace(name: $name, timezone: $timezone) {
            id
            org {
              workspaces {
                ...WorkspaceSelector_workspaces
              }
            }
          }
        }
      }
    `);

  const onCreateWorkspace = useCallback(() => {
    createWorkspace({
      variables: {
        name,
        workspaceId: props.route.params.workspaceId,
        timezone,
      },
      onCompleted: props.navigation.goBack,
    });
  }, [
    createWorkspace,
    name,
    props.navigation.goBack,
    props.route.params.workspaceId,
    timezone,
  ]);

  useNavigationHeader({
    type: "CREATE",
    onSave: () => onCreateWorkspace(),
    disabled: name.length < 1,
    saveLoading: creatWorkspaceLoading,
    title: "Create Workspace",
    onCancel: () => props.navigation.goBack(),
  });

  return (
    <Box color="surface-background" space="medium">
      <AHInput
        autoFocus
        color="surface-primary"
        value={name}
        onChangeText={setName}
        space="medium"
        cornerRadius="large"
        placeholder="Workspace Name"
      />
      <Box spaceTop="medium" />
      <TimezoneSelector
        selectedTimezone={timezone}
        onValueChange={setTimezone}
      />
    </Box>
  );
}
